/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';
import i18n from '@core/plugins/i18n';

export class Tag extends DaoModel {
  constructor(guid, legendNameEs, legendNameEn) {
    super(guid);
    this.legendNameEs = legendNameEs || '';
    this.legendNameEn = legendNameEn || '';
  }

  static toInstance(props = {}) {
    return new Tag(props.guid, props.legend_name_es, props.legend_name_en);
  }

  get legendName() {
    const language = i18n.locale;
    return this[`legendName${language.charAt(0).toUpperCase() + language.slice(1)}`];
  }
}
